import {Config, Run, State, Module} from './decorators.js';
import AuthService from './services/auth';
import UserService from './services/user';
import ConfigFactory from './services/config';
import BB from './services/bb';
import {TopBarCtrl} from './ctrls';
import topbarTpl from './topbar.html';
import pageHeaderTpl from './page_header.html';

import template404 from './404.html';
import template500 from './500.html';


@Module({
    name : 'app.routing',
    modules : [
        AuthService, UserService, ConfigFactory, BB,
    ],
})
@State({
    name: 'r',
    url: '',
    template: '<div ui-view></div><div growl limit-messages="5"></div>',
    resolve: {
    },
    ncyBreadcrumb: {
        skip: true,
    },
})
@State({
    name: 'r.in',
    url: '',
    template: '<div ui-view="topbar"></div><div ui-view></div>',
    ncyBreadcrumb: {
        skip: true,
    },
    abstract: '.top',
})
@State({
    name: 'r.in.top',
    url: '',
    views: {
        topbar: {
            template: topbarTpl,
            controller: TopBarCtrl,
        },
        '': {
            template: pageHeaderTpl,
        }
    },
    ncyBreadcrumb: {
        skipStateForTitle: true,
        label: 'Home',
    },
    abstract: '.home',
})
@State({
    name: 'error',
    template: '<div ui-view="topbar"></div><div ui-view></div>',
    ncyBreadcrumb: {
        skip: true,
    },
})
@State({
    name: 'error.404',
    views: {
        topbar: {
            template: topbarTpl,
            controller: TopBarCtrl,
        },
        '': {
            template: template404,
        }
    },
    ncyBreadcrumb: {
        skip: true
    }
})
@State({
    name: '500',
    template: template500,
})
@State({
    name: '404',
    abstract: 'error.404',
})
@Config(function($locationProvider, $urlRouterProvider) {
    "ngInject";
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise(function($injector){
        var $state = $injector.get('$state');
        $state.go('404');
    });
})
@Run(function($location, $rootScope, $state, AuthService){
    "ngInject";
    $rootScope.$state = $state;
    $rootScope.$on('$stateChangeStart', function (event, to, params, from, options) {
        if (to.auth && !AuthService.isLoggedIn) {
            $state.go('r.login', {next: $location.url()});
            event.preventDefault();
        }
    });
})
@Run(function($templateCache) {
    "ngInject";
    $templateCache.put('headerCheckBox', '<input type="checkbox" />');
})
@Run(function($log, $rootScope){
    "ngInject";
    $rootScope.$on('$stateChangeStart', function (...args) {
        $log.log(['start', ...args]);
    });
    $rootScope.$on('$stateChangeError', function (...args) {
        $log.log(['error', ...args]);
    });
    $rootScope.$on('$stateChangeSuccess', function (...args) {
        $log.log(['success', ...args]);
    });
})
@Run(($rootScope, $state, $uibModalStack) => {
    "ngInject";
    // Close all modals if user clicked back button
    $rootScope.$state = $state;
    $rootScope.$on('$stateChangeStart', () => {
        $uibModalStack.dismissAll();
    });
})
@Run(function($rootScope, $state) {
    "ngInject";
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
        event.preventDefault();

        if (!error || !error.status) {
            return;
        }
        if ([403, 404].indexOf(error.status) !== -1){
            $state.go('404');
        } else if (error.status >= 500) {
            $state.go('500');
        }
    });
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/routing.js